import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteACustomDesign,
  getCustomDesigns,
  resetState,
  updateACustomDesign,
} from "../features/customDesign/customDesignSlice";
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const CustomDesigns = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [designId, setDesignId] = useState("");

  const showModal = (id) => {
    setOpen(true);
    setDesignId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getCustomDesigns());
  }, [dispatch]);

  const customDesignState = useSelector((state) => state.customDesign.customDesigns) || [];
  const data1 = [];

  for (let i = 0; i < customDesignState.length; i++) {
    data1.push({
      key: i + 1,
      name: customDesignState[i].name,
      email: customDesignState[i].email,
      mobile: customDesignState[i].mobile,
      status: (
        <>
          <select
            name=""
            defaultValue={customDesignState[i].status ? customDesignState[i].status : "Submitted"}
            className="form-control form-select"
            id=""
            onChange={(e) => setStatus(e.target.value, customDesignState[i]._id)}
          >
            <option value="Submitted">Submitted</option>
            <option value="Contacted">Contacted</option>
            <option value="In Progress">In Progress</option>
            <option value="Resolved">Resolved</option>
          </select>
        </>
      ),
      action: (
        <>
          <Link
            className="ms-3 fs-3 text-danger"
            to={`/admin/custom-designs/${customDesignState[i]._id}`}
          >
            <AiOutlineEye />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(customDesignState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }

  const setStatus = (val, id) => {
    const data = { id: id, designData: val };
    dispatch(updateACustomDesign(data));
  };

  const deleteDesign = (id) => {
    dispatch(deleteACustomDesign(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCustomDesigns());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Custom Designs</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteDesign(designId);
        }}
        title="Are you sure you want to delete this custom design enquiry?"
      />
    </div>
  );
};

export default CustomDesigns;
